import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { Requirement } from './types';

export const getRequirements = async (
  dispatch: Dispatch,
  query: string,
): Promise<Requirement[] | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/requirements?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const registerRequirementRecord = async (
  dispatch: Dispatch,
  data: FormData,
) => {
  const response = await requestHandler({
    method: 'post',
    url: 'internal/requirements/record',
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const downloadRequirementFile = async (
  dispatch: Dispatch,
  recordId: number,
): Promise<{ signedUrl: string } | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/requirements/file/${recordId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getRequirementFileAsBlob = async (
  dispatch: Dispatch,
  recordId: number,
): Promise<{ blob: Blob; contentType: string } | null> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/requirements/file/${recordId}/blob`,
    dispatch,
    responseType: 'blob',
  });
  if (response) {
    return {
      blob: response.data,
      contentType: response.headers['content-type'],
    };
  }
  return null;
};
